import {DropdownItem, showNotification} from 'platform/components';

import {useSelector} from 'react-redux';

import {isNil} from 'ramda';

import {selectCurrentUserInfo, useSetUserAwayMutation} from '@dms/api/customer';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {SET_USER_AWAY_MUTATION_KEY} from '../constants/SET_USER_AWAY_MUTATION_KEY';
import {AvailabilityStatusDot} from './AvailabilityStatusDot';

/** Available / Away items of the away flag, inside a top-bar dropdown. */
export function AwayStatusMenu() {
  const {data: userInfo} = useSelector(selectCurrentUserInfo);
  const [setUserAway, {isLoading}] = useSetUserAwayMutation({
    fixedCacheKey: SET_USER_AWAY_MUTATION_KEY,
  });

  if (isNil(userInfo)) {
    return null;
  }

  const isAway = userInfo.isAway ?? false;

  const handleSetAway = (newIsAway: boolean) => {
    setUserAway({userId: userInfo.id, isAway: newIsAway})
      .unwrap()
      .then(() => {
        showNotification.success(
          newIsAway ? i18n.t('user.awayStatus.toastAwayOn') : i18n.t('user.awayStatus.toastAwayOff')
        );
      })
      .catch(handleApiError);
  };

  return (
    <>
      <DropdownItem
        label={i18n.t('user.awayStatus.available')}
        prefix={<AvailabilityStatusDot status="available" />}
        isActive={!isAway}
        isDisabled={isLoading}
        onClick={() => handleSetAway(false)}
        data-testid="awayStatusSelect-available"
      />
      <DropdownItem
        label={i18n.t('user.awayStatus.away')}
        prefix={<AvailabilityStatusDot status="away" />}
        isActive={isAway}
        isDisabled={isLoading}
        onClick={() => handleSetAway(true)}
        data-testid="awayStatusSelect-away"
      />
    </>
  );
}
